import { Component, OnInit } from '@angular/core';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router, NavigationEnd, RouterOutlet, OutletContext } from '@angular/router';
import { MainService } from './main/_services/main.service';

@Component({
  selector: 'hubspot-app-accelerator',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  module?: boolean;
  constructor(private router: Router, private main: MainService) { }

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof RouteConfigLoadStart) {
        this.module = false;
      }
      else if (event instanceof RouteConfigLoadEnd) {
        this.module = true;
      }
    });
  }
  prepareRoute(outlet: RouterOutlet): OutletContext {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }


  onNavigationStarted() {

  }
  onNavigationStopped() {

  }
  public get loading(): any {
    return this.main.loading;
  }
}
